import { SLCCongratsContainer } from '../../common/slc/congrats'

export const OnboardingSLCCongratsContainer = () => {
  return <SLCCongratsContainer />
}
